module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-R-33.5f4eaf17.png";